"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _Collapse = _interopRequireDefault(require("@mui/material/Collapse"));
var _material = require("@mui/material");
var _ExpandMore = _interopRequireDefault(require("../ExpandMore/ExpandMore"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _contexts = require("../../config/contexts");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _string = require("../../utils/type-checks/string");
var _common = require("../../config/common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Component to catch and display errors
 *
 * @visibleName Error Boundary
 * @author Eric Shoemaker
*/
class ErrorBoundary extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      errorData: null,
      expanded: false
    };
  }
  static contextType = (() => _contexts.SiteConfigContext)();
  static getDerivedStateFromError(error) {
    return {
      error: true,
      errorData: error
    };
  }
  componentDidCatch(error, errorInfo) {
    const {
      componentStack
    } = errorInfo;
    const {
      enabled,
      endpoint,
      method
    } = this.context.logging;
    if (enabled) {
      let payload = {};
      if (method === _common.LOGGING_METHOD_XAPI) {
        const regExp = /localhost:\d+/g;
        payload = {
          category: "ui-broken",
          severity: "high",
          message: error.message.replace(regExp, "").substring(0, 5000),
          client: {
            id: this.props.clientId,
            metaData: window.btoa(componentStack)
          },
          resources: []
        };
        fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        }).then(response => response.json()).then(response => {
          if ((0, _string.isStringOfLength)(response.incidentId)) {
            this.setState({
              incidentId: response.incidentId
            });
          }
        });
      } else if (method === _common.LOGGING_METHOD_REQUEST) {
        const params = new URLSearchParams({
          message: window.btoa(error.message),
          metaData: window.btoa(componentStack)
        });
        fetch(`${_common.URL_PUBLIC_REPORT}?${params}`);
      }
    }
  }
  render() {
    if (this.state.error) {
      const {
        errorData,
        incidentId
      } = this.state;
      const {
        enabled
      } = this.context.logging;
      let reportingOutput = null;
      let incidentIdOutput = null;
      const handleExpandClick = () => {
        this.setState({
          expanded: !this.state.expanded
        });
      };
      if (enabled) {
        if ((0, _string.isStringOfLength)(incidentId)) {
          incidentIdOutput = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
            component: "h2",
            variant: "h2"
          }, "Incident Id"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
            component: "pre"
          }, incidentId));
        }
        reportingOutput = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, "This incident has been logged for further investigation."), incidentIdOutput);
      }
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Container, {
        role: "main"
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "h1",
        variant: "h1"
      }, "An Error Occurred"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        paragraph: true
      }, "We're sorry, but an unexpected error has occurred. We apologize for the inconvenience and appreciate your patience."), /*#__PURE__*/_react.default.createElement(_ExpandMore.default, {
        expand: this.state.expanded,
        onClick: handleExpandClick,
        label: "More Details"
      }), /*#__PURE__*/_react.default.createElement(_Collapse.default, {
        in: this.state.expanded,
        timeout: "auto",
        unmountOnExit: true
      }, /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "h2",
        variant: "h2"
      }, "Error Message"), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        component: "pre"
      }, errorData.message), /*#__PURE__*/_react.default.createElement(_Typography.default, {
        paragraph: true
      }, reportingOutput))));
    }
    return this.props.children;
  }
  static defaultProps = {
    clientId: "pws-general"
  };
}

// Define propTypes;
ErrorBoundary.propTypes = {
  children: _propTypes.default.node,
  clientId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired
};

// Export component as default;
var _default = exports.default = ErrorBoundary;